import axios from 'axios'
import qs from 'qs'

/* eslint-disable */
export const getShopList = (shop_type = undefined) => axios.get('/api/applet/merchant/shops', { params: { shop_type } })

export const getViewList = (shop_type = undefined) => axios.get('/api/applet/merchant/views/get', { params: { shop_type } })

export const getShopInfo = shop_id => axios.get('/api/applet/shop/info/get', { params: { shop_id} })

export const updateAddClubInfo = clubInfo => axios.post('/api/applet/merchant/club/add/update/', qs.stringify(clubInfo))

export const updateAddViewInfo = viewInfo => axios.post('/api/applet/merchant/view/add/update/', qs.stringify(viewInfo))



// WEBPACK FOOTER //
// ./src/api/shop.js